export default __webpack_public_path__ + "static/media/about-3-comp.607def1e.png";